__turbopack_context__.v({
  "checkIcon": "_0ezdoa_checkIcon",
  "iconWrapper": "_0ezdoa_iconWrapper",
  "label": "_0ezdoa_label",
  "root": "_0ezdoa_root",
});
